import { render } from "./YandleAgentFab.vue?vue&type=template&id=42c6deb2&scoped=true"
import script from "./YandleAgentFab.vue?vue&type=script&lang=js"
export * from "./YandleAgentFab.vue?vue&type=script&lang=js"

import "./YandleAgentFab.vue?vue&type=style&index=0&id=42c6deb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c6deb2"]])

export default __exports__